import { InjectionToken } from '@angular/core';

import { INotificationService } from './notification.service.interface';

export const NOTIFICATION_SERVICE: InjectionToken<INotificationService> =
  new InjectionToken<INotificationService>('NOTIFICATION_SERVICE');
